import React, { FC } from 'react';
import { BaseIcon } from '../BaseIcon';
import { GenericIconProps } from '../types';

export const NavigationIcon: FC<GenericIconProps> = (props) => (
    <BaseIcon {...props} variant="navigation" />
);
